const PROFILE_PICTURE_MAX_SIZE_MB: number = 2
const CV_MAX_SIZE_MB: number = 6

export const PROFILE_PICTURE_FILE_CONFIG = {
    MAX_SIZE_MB: PROFILE_PICTURE_MAX_SIZE_MB,
    MAX_SIZE: PROFILE_PICTURE_MAX_SIZE_MB * 1204 * 1024, // 1MB
    ALLOWED_FILE_TYPES: ['image/png', 'image/jpeg', 'image/jpg'],
    ALLOWED_FILE_TYPES_TEXT: '.png, .jpeg, .jpg',
}

export const CV_FILE_CONFIG = {
    MAX_SIZE_MB: CV_MAX_SIZE_MB,
    MAX_SIZE: CV_MAX_SIZE_MB * 1204 * 1024, // 6MB
    ALLOWED_FILE_TYPES: ['application/pdf'],
    ALLOWED_FILE_TYPES_TEXT: '.pdf',
}